import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './forget.css';
import { resetPassword } from '../../api/api.js';
import Notification from '../../components/notification.js';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [form, setForm] = useState({
    otp: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState(null);

  // If no email in state, redirect to request page
  if (!email) {
    navigate('/forgot-password');
    return null;
  }

  const validate = () => {
    const newErrors = {};

    if (!/^\d{6}$/.test(form.otp)) {
      newErrors.otp = 'OTP must be a 6-digit number.';
    }

    if (form.newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters long.';
    }

    if (form.newPassword !== form.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match.';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      await resetPassword({ 
        email, 
        password: form.newPassword, 
        code: form.otp 
      });
      navigate('/sign-in', { 
        state: { message: 'Password reset successful. Please sign in with your new password.' }
      });
    } catch (error) {
      setNotification({ 
        type: 'error', 
        message: error.response?.data?.data?.errors?.[0]?.msg || 'Failed to reset password'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="fp-container">
        <form className="fp-form" onSubmit={handleSubmit}>
          <h2 className="fp-title">Reset Password</h2>
          <p className="fp-description">
            Enter the OTP sent to {email} and your new password.
          </p>

          <div className="fp-inputs">
            <div className="fp-input-group">
              <label htmlFor="otp">OTP</label>
              <input
                type="text"
                id="otp"
                value={form.otp}
                onChange={(e) => setForm({...form, otp: e.target.value})}
                className={errors.otp ? 'fp-input-error' : ''}
                placeholder="Enter 6-digit OTP"
                required
              />
              {errors.otp && <span className="fp-error-message">{errors.otp}</span>}
            </div>

            <div className="fp-input-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                value={form.newPassword}
                onChange={(e) => setForm({...form, newPassword: e.target.value})}
                className={errors.newPassword ? 'fp-input-error' : ''}
                placeholder="Enter new password"
                required
              />
              {errors.newPassword && <span className="fp-error-message">{errors.newPassword}</span>}
            </div>

            <div className="fp-input-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={form.confirmPassword}
                onChange={(e) => setForm({...form, confirmPassword: e.target.value})}
                className={errors.confirmPassword ? 'fp-input-error' : ''}
                placeholder="Confirm new password"
                required
              />
              {errors.confirmPassword && <span className="fp-error-message">{errors.confirmPassword}</span>}
            </div>
          </div>

          <button type="submit" className="fp-button" disabled={loading}>
            {loading ? 'Resetting Password...' : 'Reset Password'}
          </button>

          <p className="fp-back-link">
            Wrong email? <Link to="/forgot-password">Go back</Link>
          </p>
        </form>
      </div>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default ResetPassword; 